"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DependencyNotFoundError = void 0;
class DependencyNotFoundError extends Error {
    constructor(service, dependency) {
        super(`DependencyNotFoundError: ${dependency} for service ${service}`);
    }
}
exports.DependencyNotFoundError = DependencyNotFoundError;
//# sourceMappingURL=DependencyNotFoundError.js.map